import { Pipe, PipeTransform } from '@angular/core';
import { sanitizeInternalUrl } from '../utils/url-sanitizer.util';

@Pipe({
  name: 'sanitizeUrl',
  standalone: true,
  pure: true
})
export class SanitizeUrlPipe implements PipeTransform {
  transform(url: string | null | undefined): string {
    return sanitizeInternalUrl(url);
  }
}
